import React from 'react';
import { motion } from 'framer-motion';

const RequestCard = ({ request, onClick }) => {
    return (
        <motion.div
            layout
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            whileHover={{ y: -4, transition: { duration: 0.2 } }}
            onClick={onClick}
            className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer border border-gray-200 overflow-hidden"
        >
            <div className="p-4">
                <div className="flex justify-between items-start gap-2">
                    <h3 className="text-md font-bold text-gray-900 flex-1">{request.title}</h3>
                    <span className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 rounded-full font-medium">
                        {request.category}
                    </span>
                </div>
                <p className="text-sm text-gray-600 mt-2 line-clamp-2">{request.description}</p>
                <div className="mt-4 flex justify-between items-center">
                    <span className="text-sm font-medium text-gray-700">
                        {request.peopleNeeded} {request.peopleNeeded === 1 ? 'volunteer' : 'volunteers'} needed
                    </span>
                    <span className="text-sm font-bold text-black">
                        {request.points} pts
                    </span>
                </div>
            </div>
        </motion.div>
    );
};

export default RequestCard;
